module.exports = __webpack_public_path__ + "img/subAra3.402bf70f.jpg";